export default {
  queryCouponList: '/v3/mallcenter/coupon/queryCouponList',
  acquireCoupon: '/v3/mallcenter/coupon/acquireCoupon'
}
